import { apiSlice } from "../../app/api/apiSlice";

export const enhancedLoanUploadAttachmentForS3FallbackApiSlice =
	apiSlice.injectEndpoints({
		endpoints: (builder) => ({
			enhancedLoanUploadAttachmentForS3Fallback: builder.mutation({
				query: (credentials) => ({
					url: `/api/v1/loan/enhanced_loan_upload_attachment_for_s3_fallback/`,
					method: "POST",
					body: credentials?.formData,
				}),
			}),
		}),
	});

export const { useEnhancedLoanUploadAttachmentForS3FallbackMutation } =
	enhancedLoanUploadAttachmentForS3FallbackApiSlice;
